export class GetRestoreAccountCanDelete200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "canDelete",
            "baseName": "canDelete",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "blockedMessage",
            "baseName": "blockedMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreAccountCanDelete200Response.attributeTypeMap;
    }
    constructor() {
    }
}
